import { useCallback } from "react";
import CompanyService from "../../../services/CompanyService";
import { ReportReceivablesSummaryService } from "../../../services/ReportReceivablesSummaryService";
import { TranslationService } from "../../../services/TranslationService";
import { formatCurrency, formatInteger } from "../../../utils/FormatUtils";
import { useEndpointData } from "../../../utils/TableUtils";
import FloatingPanelService from "../../shared/FloatingPanel";
import { RrsAveragePaymentGraph } from "../../reports/ReportReceivablesSummary/RrsAveragePaymentGraph";
import trendIco from "../../../assets/img/trend-ico.png";
import { SkeletonLoader } from "../../shared/components/skeletonLoader/SkeletonLoader";
// import { FilterDefinition } from "../../../services/FilterService";
import { FilterRequest } from "../../../entities/Filter/FilterRequest";
// import AdvancedFilterService, { Filter } from "../../../services/AdvancedFilterService";

export const DashboardSalesDSO = (props: { noDue: number | undefined, overdue: number | undefined, totalAmount: number | undefined, currencyId?: number, dashboardFilters?: FilterRequest[] }) => {
    // const [filter, setFilter] = useState("");
    // const onFilterApply = (filterArray: string[] | undefined) => setFilter(FilterService.GetExtraFiltersRequestString(filterArray) ?? "");
    const receivablesEndpoint = useCallback(() => ReportReceivablesSummaryService.getReceivables(''), []);
    const { loading, response } = useEndpointData(receivablesEndpoint);
    const receivables = loading ? undefined : response;

    const { translate } = TranslationService;
    const { noDue, overdue, totalAmount, currencyId = CompanyService.getDefaultCurrencyId() } = props;

    // useEffect(() => {
    //     const filtersValue = props.dashboardFilters?.map<Filter>(x => ({
    //         kind: 0,
    //         definition: { Field: (parseInt(x.field) > 0 ? "additional-" : "") + x.field } as FilterDefinition,
    //         value: x.value,
    //         operator: x.operator
    //     }));
    //     // const filters = filtersValue?.map(AdvancedFilterService.filterToString);
    //     // console.log({ filters })
    //     // filters && setFilter(filters)
    // }, [props.dashboardFilters])


    const openDsoGraph = useCallback(
        async () => {
            await FloatingPanelService.showPanel({
                title: 'DSO',
                children: <RrsAveragePaymentGraph receivables={receivables} />,
                height: 450,
                width: 900,
                position: 'center'
            });
        },
        [receivables],
    )

    return (
        <div className="dashboard__sales row">

            <div className="d-flex col-10 gap-2">
                <div className="col-4 pe-0">
                    <div className="dashboard__total card-total card p-3">
                        <div className="card-body px-2">
                            <div className="card-header card-total mb-1">
                                <p className="card-text-p card-total_text">{translate.TotalReceivables}</p>
                            </div>
                            <h2 className="card-total_text">{formatCurrency(totalAmount ?? 0, currencyId, formatInteger)}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-4 pe-0">
                    <div className="dashboard__total card-total_debt card p-3">
                        <div className="card-body px-2">
                            <div className="card-header card-total_debt mb-1">
                                <p className="card-text-p card-total_debt_text">{translate.Dues}</p>
                                <span className="card-total_debt_text">{formatInteger((overdue ?? 0) / (totalAmount ? (totalAmount === 0 ? 1 : totalAmount) : 1) * 100)}%</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-end">
                                <h2 className="card-total_debt_text">{formatCurrency(overdue ?? 0, currencyId, formatInteger)}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-4 pe-0">
                    <div className="dashboard__total card-noDebt card p-3">
                        <div className="card-body px-2">
                            <div className="card-header card-noDebt mb-1">
                                <p className="card-text-p card-noDebt-text ">{translate.NoDues}</p>
                                <span className="card-noDebt-text">{formatInteger((noDue ?? 0) / (totalAmount ? (totalAmount === 0 ? 1 : totalAmount) : 1) * 100)}%</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-end">
                                <h2 className="card-noDebt-text">{formatCurrency(noDue ?? 0, currencyId, formatInteger)}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-2 pe-0 pointer">
                {(loading) ?
                    <SkeletonLoader />
                    : receivables ?
                        <div onClick={openDsoGraph} className="dashboard__total card-dso card p-3">
                            <div className="card-body px-2">
                                <div className="card-header card-dso mb-1">
                                    <p className="card-text-p card-dso-text ">DSO</p>
                                </div>
                                <div className="d-flex col align-items-center gap-1">
                                    <h2 className="card-dso-text">{Math.round(receivables.averagePeriod)} {TranslationService.translate.Days}</h2>
                                    <div className="icoTrendButton"><img src={trendIco} alt="trendIco" width={"28px"} height={"28px"} /></div>
                                </div>
                            </div>
                        </div> : null}
            </div>

        </div>
    );
}

export default DashboardSalesDSO;